import { Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Layout from './components/Layout';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Home = lazy(() => import('./pages/Home'));
const Architecture = lazy(() => import('./pages/Architecture'));
const ArchitectureDetail = lazy(() => import('./pages/ArchitectureDetail'));
const AIChat = lazy(() => import('./pages/AIChat'));

function App() {
  useEffect(() => {
    Aos.init({
      once: true,
    });
  }, []);
  return (
    <Suspense fallback={<div style={{ minHeight: '100vh', background: '#0a0a0f' }} />}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="architecture" element={<Architecture />} />
          <Route path="architecture/:slug" element={<ArchitectureDetail />} />
          <Route path="ai-chat" element={<AIChat />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
